import noInternetAnimation from '../../../assets/lottie/noInternetAnimation.json';
import Lottie from 'lottie-react';
import { useNoInternet } from './useNoInternet';
import { Button } from '../Buttons';

export type NoInternetProps = {
  children: React.ReactNode;
};

/**
 * NoInternet component - Monitors network status and displays no-internet UI when offline
 * When online, renders children normally
 */
const NoInternet: React.FC<NoInternetProps> = ({ children }) => {
  const { isOnline, handleRetry } = useNoInternet();
  // If online, render children normally
  if (isOnline) {
    return <>{children}</>;
  }

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-gray-50">
      {noInternetAnimation ? (
        <Lottie
          animationData={noInternetAnimation}
          loop
          style={{
            height: '20%',
            width: '20.5%', // Maintains 160:128 ratio (5:4) - width = height * 1.25
            aspectRatio: '5/4',
          }}
        />
      ) : (
        <div className="flex items-center justify-center">
          <div className="text-gray-400">Ładowanie...</div>
        </div>
      )}
      <div className="flex flex-col items-center justify-center gap-5">
        <div className="flex flex-col items-center justify-center gap-1">
          <p className="text-titleMedium text-on-surface-variant">
            No internet connection
          </p>
          <p className="text-bodyLarge text-on-surface-variant">
            Please check your internet connection and try again.
          </p>
        </div>
        <Button
          className="cursor-pointer"
          label="Retry"
          onClick={handleRetry}
        />
      </div>
    </div>
  );
};

export default NoInternet;
